import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const PinEmptyIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M16.8 6.7v5.4l1.7 2.56v1.7h-5.11V20l-1.14.9-1.14-.9v-3.64H6v-1.7l1.7-2.56V6.7c0-.93 1.06-1.7 2-1.7h5.1c.95 0 2 .76 2 1.7Zm-6.82.57v5.43l-.8 1.4h6.2l-.86-1.4V7.27H9.98Z" />
    </SvgIcon>
);
